import styled from 'styled-components';

import { spacing } from '@sine/sine-ui-components';

export const PageContainer = styled.div`
  position: relative;
  padding: ${spacing(4)};
  min-width: 300px;
  max-width: 1170px;
  margin: 0 auto;
`;
